module.exports = __webpack_public_path__ + "static/akaash-72405dd4fda7e8cadb67510555e64b1d.jpg";